import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createGearApi, storeGearApi } from './gearSlice';
import GearForm from './GearForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { initialValues, pictureAttributeNames } from './initialValue';

function GearCreate() {
    const [resetCount, setResetCount] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(storeGearApi({ navigate, values }));
    };

    return (
        <GearForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default GearCreate;
